class ProductCardInformationSel2 extends HTMLElement {
  constructor() {
    super();
    this.variantSelect = null;
    this.optionSelector = null;
  }

  connectedCallback() {
    this.variantSelect = this.querySelector('select[data-variant-select]');
    this.optionSelector = this.querySelector('.card__variant-select select');

    if (this.variantSelect && this.optionSelector) {
      this.optionSelector.addEventListener('input', () => this.onOptionChange());
      // Встановлюємо перший варіант на старті
      this.onOptionChange();
    }
  }

  onOptionChange() {
    const selectedValue = this.optionSelector.value;

    // Знаходимо правильний варіант у hidden select
    const variantOption = Array.from(this.variantSelect.options).find(
      // option => option.dataset.option1 === selectedValue
      option => option.dataset['option-1'] === selectedValue
    );

    if (variantOption) {
      // Оновлюємо hidden select для Shopify
      const variantIdInput = this.querySelector('input.product-variant-id');
      if (variantIdInput) {
        variantIdInput.value = variantOption.value; // variantOption.value — id потрібного варіанту
      }

      // Викликаємо подію change → Shopify JS підхопить
      this.variantSelect.dispatchEvent(new Event('change', { bubbles: true }));

      // Не обов’язково, але можна додатково оновити ціну, кнопку
      const priceEl = this.querySelector('.price-item--sale, .price-item--regular');
      if (priceEl) {
        priceEl.textContent = (variantOption.dataset.price / 100).toFixed(2) + '₪';
      }
    }
  }
}

customElements.define('product-card-information-sel2', ProductCardInformationSel2);
